import Axios from "axios";
import {
    SET_SUPPLIER_MAP_LIST,
    UNSET_SUPPLIER_MAP_LIST,
  } from "@/store/mutation-types";
import { saveUpdateSupplierMap, getSupplierMapList } from "@/store/api";
// initial state
const state = {
  getSupplierMapList: [],
};

const getters = {
  getSupplierMapList(state) {
    return state.getSupplierMapList;
  },
};
const mutations = {
  [SET_SUPPLIER_MAP_LIST](state, data) {
    state.getSupplierMapList = data;
  },
  [UNSET_SUPPLIER_MAP_LIST](state) {
    state.getSupplierMapList = [];
  },
};

const actions = {

  saveUpdateSupplierMap({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateSupplierMap, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getSupplierMapList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getSupplierMapList, data)
        .then(function (response) {
          commit('SET_SUPPLIER_MAP_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_SUPPLIER_MAP_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
